<template>
<!--  <div id="courseware" @touchmove="noscroll">-->
  <div id="courseware">
    <!--课程弹窗-->
    <div id="popup-all">
      <h3>全部</h3>
      <div v-if="wareList.length === 0" class="no-ware">
        <p>暂无课件下载</p>
      </div>
      <ul v-else>
<!--        <li><p>第一节（已更新）</p><span></span></li>-->
<!--        <li class="playing"><p>当前课程</p><span></span></li>-->
        <li v-for="(item, index) in wareList" :key="index" @click="download(item.courseware)" :alt="item.id + '' + current_video_id" :class="current_video_id === item.id ? 'playing' : ''">
          <p>{{index + 1}} | {{item.name}}</p>
          <span></span>
        </li>
      </ul>
    </div>
    <div class="bg" @click="hideList()"></div>
  </div>
</template>

<script>
export default {
  name: 'CourseWare',
  data () {
    return {
      wareList: {}
    }
  },
  props: [
    'class_id',
    'course_id',
    'current_video_id'
  ],
  mounted () {
    this.getWareList()
  },
  methods: {
    getWareList () {
      let data = {
        class_id: this.class_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_course_ware',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.wareList = res.data.data
            console.log(this.wareList)
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    download (url) {
      window.location.href = url
    },
    hideList () {
      this.$emit('listenShow')
    },
    noscroll (event) {
      event.preventDefault()
    }
  }
}
</script>

<style scoped lang="stylus">
  #courseware
    #popup-all
      position: fixed
      bottom: 0
      left: 0
      z-index: 10001
      width: 7.5rem
      height: 9.1rem
      padding: .4rem
      background-color: #fff
      overflow: auto
      -webkit-overflow-scrolling: touch
      h3
        width: 1.36rem
        line-height: .6rem
        background-color: #EEEEEE
        font-size: .26rem
        color: #5D5D5D
        text-align: center
        -webkit-border-radius: .3rem
        -moz-border-radius: .3rem
        border-radius: .3rem
      .no-ware
        p
          margin: .3rem .2rem
          font-size: .28rem
          color: #2E2E2E
      ul
        height: auto
        li
          display: flex
          justify-content: space-between
          align-items: center
          width: 6.7rem
          height: .94rem
          border-bottom: .02rem solid #F2F2F2
          p
            font-size: .28rem
            color: #2E2E2E
          span
            display: block
            width: .4rem
            height: .4rem
            background: url(../../../../assets/icon/courseware_icon_0.png) no-repeat center
            -webkit-background-size: 100%
            background-size: 100%
          &.playing
            p
              color: #FF6445
            span
              display: block
              width: .4rem
              height: .4rem
              background: url(../../../../assets/icon/courseware_icon_1.png) no-repeat center
              -webkit-background-size: 100%
              background-size: 100%
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 10000
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)
</style>



// WEBPACK FOOTER //
// src/components/share/popup/class/CourseWare.vue